import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { stringLength, subString } from '@csg/g11n-sdk-core';
import { Field, getId } from '../Field/Field';
import { textInputWidth } from '../Field/Field.styled';
import { FieldError } from '../Field/FieldError';
import { formErrorAttribute } from '../Form';
import { useInputContext } from '../Form/withInputContext';
import { useTranslate } from '../util';
import { forwardDataAttributes, setDataAttributes } from '../util/getDataAttributes';
import { Hint } from './Hint';
import { StyledTextArea, StyledTextAreaWrapper } from './TextArea.styled';
export function TextAreaField(props) {
  var id = getId(props);
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id
  }), /*#__PURE__*/React.createElement(TextArea, _extends({
    maxWidth: textInputWidth
  }, props, {
    id: id
  })));
}
function _TextArea(props) {
  var t = useTranslate();
  var inputContext = useInputContext({
    forceShowValidation: props.forceShowValidation
  });
  var valueLength = stringLength(props.value);
  var maxCharacterWarning = props.value && props.maxLength && props.maxLength <= valueLength ? t('citrix-ui:validation.exceed_max_chars') : undefined;
  var requiredError = props.required && (!props.value || !props.value.trim()) ? t('citrix-ui:validation.enter_required_value') : undefined;
  var isErrored = !props.disabled && (!!props.errorMessage || !!requiredError);
  var showError = inputContext.isDirty && isErrored;
  var showWarning = !!maxCharacterWarning || !props.disabled && inputContext.isDirty && !!props.warningMessage;
  return /*#__PURE__*/React.createElement(StyledTextAreaWrapper, {
    hasRows: !!props.rows,
    style: {
      maxWidth: props.maxWidth
    }
  }, /*#__PURE__*/React.createElement(StyledTextArea, _extends({
    id: props.id,
    style: {
      resize: props.resize
    },
    showError: showError,
    showWarning: showWarning,
    canResize: !!props.resize,
    rows: props.rows,
    onBlur: onBlur,
    autoFocus: !!props.autoFocus,
    placeholder: props.placeholder,
    value: props.value || '',
    disabled: !!props.disabled,
    readOnly: props.readOnly,
    ref: props.textAreaRef,
    onChange: onChange,
    "aria-label": props['aria-label'],
    "aria-labelledby": props['aria-labelledby']
  }, formErrorAttribute(isErrored), setDataAttributes(props, 'textarea'))), /*#__PURE__*/React.createElement(FieldError, _extends({
    alertAction: props.alertAction,
    error: showError ? props.errorMessage || requiredError : undefined,
    warning: showWarning ? props.warningMessage || maxCharacterWarning : undefined,
    htmlFor: props.id
  }, forwardDataAttributes(props))), /*#__PURE__*/React.createElement(Hint, _extends({
    hint: props.hint,
    showCharacterLimit: !!props.maxLength,
    currentLength: valueLength,
    maxLength: props.maxLength
  }, forwardDataAttributes(props))));
  function onChange(e) {
    if (props.validateOnChange) {
      inputContext.makeDirty();
    }
    var value = e.currentTarget.value;
    if (props.maxLength && value.length > props.maxLength) {
      value = subString(value, 0, props.maxLength);
    }
    props.onChange && props.onChange(value);
  }
  function onBlur(e) {
    inputContext.makeDirty();
    props.onBlur && props.onBlur(e.currentTarget.value, e);
  }
}
export var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(_TextArea, _extends({
    textAreaRef: ref
  }, props));
});